import React from 'react';
import { SelectItemMode } from '@atlaskit/editor-common/type-ahead';
import { Pressable, Stack } from '@atlaskit/primitives';
import { getMappedItems } from '../utils';
export var QuickInsertPanel = function QuickInsertPanel(_ref) {
  var items = _ref.items,
    onItemInsert = _ref.onItemInsert;
  var mappedItems = getMappedItems(items);
  var structureItems = [];
  var dataItems = [];
  var apps = [];
  for (var i = 0; i < mappedItems.length; i++) {
    if (mappedItems[i].category === 'structure') {
      structureItems.push(mappedItems[i]);
    } else if (mappedItems[i].category === 'data') {
      dataItems.push(mappedItems[i]);
    } else {
      apps.push(mappedItems[i]);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, null, structureItems.map(function (item) {
    return /*#__PURE__*/React.createElement(Pressable, {
      key: item.tempKey,
      onClick: function onClick() {
        return onItemInsert(SelectItemMode.SELECTED, item.tempKey);
      }
    }, "".concat(item.tempKey, " ").concat(item.title));
  })), /*#__PURE__*/React.createElement("div", null, "-------"), /*#__PURE__*/React.createElement(Stack, null, dataItems.map(function (item) {
    return /*#__PURE__*/React.createElement(Pressable, {
      key: item.tempKey,
      onClick: function onClick() {
        return onItemInsert(SelectItemMode.SELECTED, item.tempKey);
      }
    }, "".concat(item.tempKey, " ").concat(item.title));
  })));
};